import {RouteGroupSelectorProps, routeGroupsSelector, useGetAllRouteGroupsQuery} from "@ots-frontend/ots-data";
import {useMemo} from "react";
import {BaseRouteGroupMultiSelect, BaseRouteGroupMultiSelectProps} from "./BaseRouteGroupMultiSelect";

export type RouteGroupMultiSelectProps = Omit<BaseRouteGroupMultiSelectProps, "entities" | "loading"> & {
  selector?: RouteGroupSelectorProps
}

export const RouteGroupMultiSelect = (props: RouteGroupMultiSelectProps) => {
  const {selector, ...rest} = props;

  const selectRouteGroups = useMemo(() => {
    return routeGroupsSelector();
  }, []);

  const {routeGroups, isLoading} = useGetAllRouteGroupsQuery(selector?.regionId, {
    selectFromResult: (result) => ({
      routeGroups: selectRouteGroups(result, selector),
      isLoading: result.isLoading
    })
  });

  return <BaseRouteGroupMultiSelect entities={routeGroups} loading={isLoading} {...rest} />;
};
